module.exports = __webpack_public_path__ + "img/graphic-design.b46b129b.jpg";